<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Levels",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Levels",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Levels",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Level Name",
          sortable: true,
        },
        {
          key: "level_type",
          label: "Level Type",
          sortable: true,
        },
        {
          key: "short",
          label: "Short Name",
          sortable: true,
        },
        {
          key: "courses.name",
          label: "Course",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        short: "",
        level: "",
        levelType: ""
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        short: "",
        level: "",
        id: "",
      },
      levelTypeData: [
        { name: "Beginner", id: 1 },
        { name: "Mid-Beginner", id: 2 },
        { name: "Intermediate/Fluent", id: 2 },
      ],
      existingClass: [],
      nameError: "",
      shortError: "",
      levelError: "",
      levelTypeError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("classes", ["AllCourses", "AllClasses", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllClasses.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllClasses.length;
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchCourses: "classes/fetchCourses",
      AddClass: "classes/addClass",
      EditClass: "classes/editClass",
      DeleteClass: "classes/deleteClass",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllClasses.length;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.shortError = "";
      this.levelError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.short = "";
      this.data.level = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.short = "";
      this.editdata.level = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingClass = this.AllClasses.filter((classx) => {
          return classx.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingClass.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingClass = [];
      }
    },
    addClass(modal) {
      if (this.data.name == "") {
        this.nameError = "Level Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.short == "") {
        this.shortError = "Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      if (this.data.level == "") {
        this.levelError = "Course field can't be empty";
        return;
      } else {
        this.levelError = "";
      }
      if (this.existingClass.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddClass(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.level = values.item.level;
      this.editdata.short = values.item.short;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteClass(modal) {
      this.modal = modal;
      this.DeleteClass(this.deletedata);
      this.closeModal(modal);
    },
    editClass(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Level Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.short == "") {
        this.shortError = "Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      if (this.editdata.name == "") {
        this.levelError = "Course field is required";
        return;
      } else {
        this.levelError = "";
      }
      this.modal = modal;
      this.EditClass(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchClasses();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_class')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Available Levels
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-class-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_class')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllClasses"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(level_type)="data">
                  <span v-if="data.item.level_type == 1">Beginner</span>
                  <span v-else>Intermediate/Fluent</span>
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-class-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_class')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-class-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_class')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-class-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_class')
          )
        "
      >
        <template #modal-title> Add New Level </template>
        <div class="form-group mb-3">
          <label>Full Name <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="e.g B.1"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name <small class="text-danger">*</small></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="e.g B.1"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Course <small class="text-danger">*</small></label>
          <div class="input-group">
            <model-list-select
              :list="AllCourses ? AllCourses : []"
              v-model="data.level"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Course"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="levelError">
            <em>{{ levelError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
            <label>Level Type <small class="text-danger">*</small></label>
            <div class="input-group">
              <model-list-select
                :list="levelTypeData ? levelTypeData : []"
                v-model="data.levelType"
                option-value="id"
                option-text="name"
                class="mb-3"
                placeholder="Select Type"
                @input="resetError()"
              >
              </model-list-select>
            </div>
            <div class="text-danger" v-if="levelTypeError">
              <em>{{ levelTypeError }}</em>
            </div>
          </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-class-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addClass('add-class-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-class-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_class')
          )
        "
      >
        <template #modal-title> Edit Level {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Level Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="e.g P.1"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="editdata.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Course</label>
          <div class="input-group">
            <model-list-select
              :list="AllCourses ? AllCourses : []"
              v-model="editdata.level"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Class Level"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="levelError">
            <em>{{ levelError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-class-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editClass('edit-class-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete class starts -->
      <b-modal id="delete-class-modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <h4 class="text-danger">
            Delete Level {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Level {{ deletedata.name }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-class-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteClass('delete-class-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
